// extracted by mini-css-extract-plugin
export default {"galleryItem":"gallery-item_galleryItem__yHvKe","image":"gallery-item_image__uO9nb","galleryItemTitle":"gallery-item_galleryItemTitle__kWVrQ"};